<div
  [ngStyle]="{ direction: isRTL ? 'rtl' : 'ltr' }"
  class="unsubscribe-container"
  [ngClass]="{ 'is-mobile-view': isMobileView }"
>
  @if (isLoading) {
  <mat-spinner [diameter]="70"></mat-spinner>
  }@else{
  <img
    class="unsubscribe-svg-image"
    [ngClass]="{ 'is-mobile-view': isMobileView }"
    src="../../assets/unsubscribe/jwtRS256.svg"
    alt="unsubscribe image"
  />
  @if (!isSuccess) {
   @if (unsubscribeFromType===unsubscribeTypeInstance.Insights ) {
  <span class="unsubscribe-text" [ngClass]="{ 'is-mobile-view': isMobileView }">
    {{ "unsubscribe.unsubscribeTextFromInsights" | translate }}
  </span>
  } @else if (unsubscribeFromType===unsubscribeTypeInstance.Questions) {
  <span class="unsubscribe-text" [ngClass]="{ 'is-mobile-view': isMobileView }">
    {{ "unsubscribe.unsubscribeTextFromQuestiones" | translate }}
  </span>
  }
  <button class="unsubscribe-button" (click)="unsubscribe()">
    {{ "unsubscribe.unsubscribeButtonText" | translate }}
  </button>
  } } @if (isSuccess) {
  <span class="unsubscribe-text" [ngClass]="{ 'is-mobile-view': isMobileView }">
    {{ "unsubscribe.successMsg" | translate }}
  </span>
  } @if (isErr) {
  <span class="unsubscribe-text" [ngClass]="{ 'is-mobile-view': isMobileView }">
    {{ "unsubscribe.errMsg" | translate }}
    {{this.err}}
  </span>
  }
</div>
